export default __webpack_public_path__ + "static/media/562.32ca2d82.svg";